<template>
  <QlikObjectDrawer 
    :show="!!slotEditing" 
    :type="slotEditorType"
    @selected="selected" 
    @closed="finishEdition" 
  />
</template>

<script>
import QlikObjectDrawer from '@/components/Qlik/QlikObjectDrawer'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'DashboardSlotEditor',
  components: { QlikObjectDrawer },
  computed: {
    ...mapState('dashboard', [
      'slotEditing',
      'slotEditorType'
    ]),
  },
  methods: {
    ...mapMutations('dashboard', [
      'setSlotEditing',
      'setSlotEditorType'
    ]),
    ...mapActions('dashboard', [
      'updateSlot'
    ]),
    finishEdition () {
      this.setSlotEditing(null)
      this.setSlotEditorType(null)
    },
    async selected({qObjectId, qAppId}) {
      await this.updateSlot({qObjectId, qAppId})
      this.finishEdition()
    }
  }
}
</script>